import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("GiftedTalentedFiscalPermissions")
export class GiftedTalentedFiscalPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
}